/* tslint:disable */
/* eslint-disable */
// @ts-nocheck
/**
 * API
 * Audius V1 API
 *
 * The version of the OpenAPI document: 1.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { exists, mapValues } from '../runtime';
import type { UserCoinWithAccounts } from './UserCoinWithAccounts';
import {
    UserCoinWithAccountsFromJSON,
    UserCoinWithAccountsFromJSONTyped,
    UserCoinWithAccountsToJSON,
} from './UserCoinWithAccounts';

/**
 * 
 * @export
 * @interface UserCoinResponse
 */
export interface UserCoinResponse {
    /**
     * 
     * @type {UserCoinWithAccounts}
     * @memberof UserCoinResponse
     */
    data?: UserCoinWithAccounts;
}

/**
 * Check if a given object implements the UserCoinResponse interface.
 */
export function instanceOfUserCoinResponse(value: object): value is UserCoinResponse {
    let isInstance = true;

    return isInstance;
}

export function UserCoinResponseFromJSON(json: any): UserCoinResponse {
    return UserCoinResponseFromJSONTyped(json, false);
}

export function UserCoinResponseFromJSONTyped(json: any, ignoreDiscriminator: boolean): UserCoinResponse {
    if ((json === undefined) || (json === null)) {
        return json;
    }
    return {
        
        'data': !exists(json, 'data') ? undefined : UserCoinWithAccountsFromJSON(json['data']),
    };
}

export function UserCoinResponseToJSON(value?: UserCoinResponse | null): any {
    if (value === undefined) {
        return undefined;
    }
    if (value === null) {
        return null;
    }
    return {
        
        'data': UserCoinWithAccountsToJSON(value.data),
    };
}

